import { render, staticRenderFns } from "./Payslipdetailpopup.vue?vue&type=template&id=1cd933e0"
import script from "./Payslipdetailpopup.vue?vue&type=script&lang=js"
export * from "./Payslipdetailpopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports